export default __webpack_public_path__ + "static/media/330_store04-en-mobile.e3af48d3.png";